import { Module } from '@thro-types/modules-selections';
import { ShibUser } from '@thro-types/users';

import { TFunction } from 'i18next';

import { userDataToLecturerOption } from 'app/containers/AWPM-FWPM/helper';

import { ActiveState } from '.';

export const isModuleActive = (module: Module) => {
  return module?.activeState !== ActiveState.Inactive;
};

export const getModuleLecturer = (
  module: Module & { lecturersUsers: (string | ShibUser)[]; unregisteredLecturers: string[] },
  t: TFunction
) => [
  ...(!!module.lecturersUsers?.length
    ? module.lecturersUsers?.map(lecturer => userDataToLecturerOption(lecturer, t).label)
    : []),
  ...(!!module.unregisteredLecturers?.length ? module.unregisteredLecturers : [])
];
